import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const NotFound = () => {
  return (
    <section className="bg-gray-100 text-gray-800">
      <div className="min-h-screen py-8 px-4 mx-auto container flex items-center">
        <div className="mx-auto text-center" style={{ maxWidth: '600px' }}>
          <div className="mb-8 inline-block bg-gray-200 p-6 rounded-full">
            <svg
              className="w-20 h-20 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h1 className="mb-4 text-9xl font-bold text-green-700">404</h1>
          <p className="mb-4 text-2xl font-semibold text-gray-700">
            Looks like you've wandered off the path
          </p>
          <p className="mb-8 text-lg text-gray-600 max-w-md mx-auto">
            While our gardeners track down the missing page, let's get you back to safety.
          </p>

          <div className="space-y-4">
            <Link
              to="/"
              className="inline-block px-8 py-3 text-white bg-green-600 hover:bg-green-700 rounded-lg transition-colors duration-200 font-medium"
            >
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </section>

  );
};

export default NotFound;
